import React from "react";

const ReferAndEarnHeader = ({ image, text }) => {
  return (
    <div className="flex rounded-3xl w-full pt-12">
      <div className=" w-full relative flex flex-col md:flex-row rounded-3xl">
        {/* Left Section (Image) */}
        <div className="w-full md:w-2/4 text-center flex items-center justify-center relative min-h-[200px]">
          <img
            src={image}
            alt="refer-section"
            className="absolute mb-2 md:-bottom-5 object-contain left-3   mt-[60px] md:mt-0"
           
          />
        </div>

        {/* Right Section (Text) */}
        <div className="w-full md:w-2/4 text-center flex items-center justify-center lg:justify-start   mt-[40px] md:mt-0 " >
          <span className="lg:-left-[50px] font-semibold inline-block lg:relative text-xl lg:text-3xl  lg:top-[-5px] my-10 md:mt-16 md:mb-20 w-1/2 md:w-full color-of-text">
            {text}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ReferAndEarnHeader;
